export default "__VITE_ASSET__rsBMLArs__"